module.exports = __webpack_public_path__ + "static/media/F3.00672382.jpg";